export default function toPLN(amount) {
    return new Intl.NumberFormat('pl-PL', { 
        style: 'currency', 
        currency: 'PLN', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
    }).format(amount = amount || 0);
};
